import {useQuery} from 'react-query'
import {BundleEditModalForm} from './BundleEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getBundleById} from '../core/_requests'

const BundleEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: bundle,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-bundle-${itemIdForUpdate}`,
    () => {
      return getBundleById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <BundleEditModalForm isBundleLoading={isLoading} bundle={{id: undefined}} />
  }

  if (!isLoading && !error && bundle) {
    console.log({bundle, },"its bundle")
    console.log(typeof bundle,"its bundle")
    return <BundleEditModalForm isBundleLoading={isLoading} bundle={bundle} />
  }

  return null
}

export {BundleEditModalFormWrapper}
